import React from 'react';
import { Shield, Lock, Eye, Trash2, Mail, Database } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './PolicyPage.css';
import './PrivacyPage.css';

const PrivacyPolicyPage = () => {
  return (
    <>
      <Navbar />
      <div className="policy-page">

        <section className="policy-hero">
          <div className="container">
            <div className="policy-hero-badge"><Shield size={14} /> Privacy Policy</div>
            <h1 className="policy-hero-title">Your <span>Privacy</span> Matters</h1>
            <p className="policy-hero-sub">How Aurora CM Group Ltd collects, uses, and protects your personal information.</p>
          </div>
        </section>

        <section className="policy-body">
          <div className="container">
            <div className="policy-highlights">
              <div className="policy-highlight-card">
                <div className="policy-highlight-icon"><Lock size={24} /></div>
                <h3>Secure Storage</h3>
                <p>Industry-standard encryption</p>
              </div>
              <div className="policy-highlight-card">
                <div className="policy-highlight-icon"><Eye size={24} /></div>
                <h3>Transparency</h3>
                <p>You know what we collect</p>
              </div>
              <div className="policy-highlight-card">
                <div className="policy-highlight-icon"><Database size={24} /></div>
                <h3>Limited Sharing</h3>
                <p>Only with trusted partners</p>
              </div>
              <div className="policy-highlight-card">
                <div className="policy-highlight-icon"><Trash2 size={24} /></div>
                <h3>Right to Delete</h3>
                <p>You can request data removal</p>
              </div>
            </div>

            <div className="policy-content">
              <div className="policy-section">
                <h2><Database size={20} /> What We Collect</h2>
                <p>Aurora CM Group Ltd may collect the following personal data when you use our website:</p>
                <ul>
                  <li><strong>Identity data:</strong> First name, last name, username</li>
                  <li><strong>Contact data:</strong> Email address, phone number, delivery address</li>
                  <li><strong>Financial data:</strong> Payment method details (processed securely via Paystack)</li>
                  <li><strong>Transaction data:</strong> Order history, products purchased, payment amounts</li>
                  <li><strong>Technical data:</strong> IP address, browser type, device information</li>
                  <li><strong>Usage data:</strong> How you use our website and services</li>
                  <li><strong>Marketing preferences:</strong> Newsletter and communication preferences</li>
                </ul>
              </div>

              <div className="policy-section">
                <h2><Eye size={20} /> How We Use Your Data</h2>
                <p>We use your personal data for the following purposes:</p>
                <ul>
                  <li>To process and deliver your orders</li>
                  <li>To manage your account and loyalty program membership</li>
                  <li>To facilitate secure online payments</li>
                  <li>To send order confirmations and delivery updates</li>
                  <li>To improve our products, services, and website</li>
                  <li>To send marketing communications where you have consented</li>
                  <li>To comply with legal and regulatory obligations</li>
                  <li>To detect and prevent fraud</li>
                </ul>
              </div>

              <div className="policy-section">
                <h2><Lock size={20} /> Data Security</h2>
                <p>We take data security seriously. Our measures include:</p>
                <ul>
                  <li>HTTPS encryption across all pages</li>
                  <li>PCI-DSS compliant payment processing via Paystack</li>
                  <li>Secure server infrastructure with access controls</li>
                  <li>Regular security reviews and updates</li>
                </ul>
                <p>We never store raw card details on our servers. All payment data is handled by our payment processor.</p>
              </div>

              <div className="policy-section">
                <h2><Database size={20} /> Data Sharing</h2>
                <p>We do not sell your personal data. We may share it with trusted third parties only for:</p>
                <ul>
                  <li><strong>Payment processing:</strong> Paystack, mobile money providers</li>
                  <li><strong>Delivery & logistics:</strong> Courier and delivery partners</li>
                  <li><strong>IT services:</strong> Hosting and website infrastructure providers</li>
                  <li><strong>Legal compliance:</strong> When required by law or court order</li>
                </ul>
                <p>All third parties are contractually bound to keep your data secure and use it only for specified purposes.</p>
              </div>

              <div className="policy-section">
                <h2><Eye size={20} /> Your Rights</h2>
                <p>You have the following rights regarding your personal data:</p>
                <div className="privacy-rights-grid">
                  <div className="privacy-right"><strong>Access</strong><span>Request a copy of your data</span></div>
                  <div className="privacy-right"><strong>Correct</strong><span>Update inaccurate information</span></div>
                  <div className="privacy-right"><strong>Delete</strong><span>Request data removal</span></div>
                  <div className="privacy-right"><strong>Opt Out</strong><span>Unsubscribe from marketing</span></div>
                  <div className="privacy-right"><strong>Portability</strong><span>Receive your data in a portable format</span></div>
                  <div className="privacy-right"><strong>Object</strong><span>Object to certain processing</span></div>
                </div>
                <p>To exercise any of these rights, contact our Data Protection Officer.</p>
              </div>

              <div className="policy-section">
                <h2><Trash2 size={20} /> Cookies</h2>
                <p>By visiting auroragh.com, you accept the use of cookies. We use cookies to:</p>
                <ul>
                  <li>Keep you logged in during your session</li>
                  <li>Remember your cart and preferences</li>
                  <li>Analyze website traffic (Google Analytics)</li>
                  <li>Improve your browsing experience</li>
                </ul>
                <p>You can manage cookie preferences through our Cookie Consent banner or your browser settings.</p>
              </div>

              <div className="policy-section">
                <h2><Mail size={20} /> Contact — Data Protection</h2>
                <p>For all data protection inquiries:</p>
                <div className="policy-contact-grid">
                  <a href="mailto:accounts@auroragh.com" className="policy-contact-item">
                    <strong>DPO Email</strong>
                    <span>accounts@auroragh.com</span>
                  </a>
                  <a href="tel:0505078077" className="policy-contact-item">
                    <strong>DPO Phone</strong>
                    <span>0505078077</span>
                  </a>
                </div>
                <p className="policy-hours">This policy is governed by Ghanaian law. Disputes settled in Accra courts.</p>
              </div>
            </div>
          </div>
        </section>

      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicyPage;